<template>
  <div
    class="form-controls"
    :class="{ 'form-controls--single': hasSingleButton }"
  >
    <template v-if="currentStep === 1">
      <el-button
        type="primary"
        @click="goToNextStep"
      >
        <app-i18n code="common.next" />
      </el-button>
    </template>

    <template v-else-if="currentStep > 1 && currentStep < 6">
      <el-button
        type="secondary"
        @click="goToPrevStep"
        :disabled="isLoading"
      >
        <app-i18n code="common.back.default" />
      </el-button>
      <el-button
        :class="{ 'el-button--loading': isLoading }"
        type="primary"
        @click="goToNextStep"
        :disabled="isLoading"
      >
        <app-loading-spinner v-if="isLoading" />
        <app-i18n
          v-else
          :code="currentStep === 5 ? 'common.complete' : 'common.next'"
        />
      </el-button>
    </template>

    <template v-if="currentStep === 6">
      <el-button
        type="primary"
        @click="goToHome"
      >
        <app-i18n code="common.done" />
      </el-button>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'appFormControls',
  computed: {
    ...mapState('form', ['currentStep']),
    ...mapState('teamRegistration', ['isLoading']),
    hasSingleButton() {
      return this.currentStep === 1 || this.currentStep === 6
    },
  },
  methods: {
    ...mapActions(['clearStore']),
    ...mapActions('form', ['goToNextStep', 'goToPrevStep']),
    goToHome() {
      this.$router.push({
        name: 'home',
        params: {
          slug: this.$route.params.slug,
        },
      })
      this.clearStore()
    },
  },
}
</script>

<style lang="scss" scoped>
.form-controls {
  --spinner-size: 28px;

  display: flex;

  @include desktop {
    justify-content: space-between;
  }

  .el-button {
    flex-grow: 1;
    font-size: 12px !important;

    &--loading {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      .loading-spinner {
        width: var(--spinner-size);
        height: var(--spinner-size);
      }
    }

    @include mobile {
      font-size: 14px !important;
    }

    @include desktop {
      flex-grow: initial;
      width: 160px;
    }
  }

  &--single {
    @include desktop {
      justify-content: center;
    }

    .el-button {
      flex-grow: 1;

      @include desktop {
        flex-grow: initial;
        width: 288px;
      }
    }
  }
}
</style>

<style lang="scss">
.form-controls {
  .el-button {
    &--loading {
      .loading-spinner {
        position: relative;
        top: initial;
        margin-top: 0;

        svg {
          width: var(--spinner-size);
          height: var(--spinner-size);

          circle {
            stroke: #ffffff;
          }
        }
      }
    }
  }
}
</style>